module.exports = __webpack_public_path__ + "img/csat-logo.f39ef56f.png";